export const MAX_BUILDINGS_COUNT = 9

export const CAROUSEL_ITEM_WIDTH = 280



// WEBPACK FOOTER //
// ./containers/BuildingsCarousel/constants.jsx